export default [
    {
      title: 'menu.Quotation',
      icon: 'FileTextIcon',
      tagVariant: 'light-danger',
      route:'quotation'
    },
  ]